import React, {useState, useEffect} from "react"
import DownloadCard from "./DownloadCard"


function GameLanding(props) {
    const [text, setText] = useState("")
    
    const [downloadText] = useState("The download button on this page will provide you with Larry's current investigation files. You should print these and keep them safe as different parts will be needed throughout the game. Along the way there may be some additional documents to print as you uncover more secrets.")
    
    const [envelopeText] = useState("You have been provided with Larry's current investigation files and four sealed evidence envelopes. Do not open these envelopes until instructed. Opening them too soon will reveal spoilers for your game.")
    
    const [rejoinText] = useState("You are currently on part " + props.playerStage + " of the investigation. Click the button below to jump back in at that point.")
    
    function changeText() {
        if (props.playerStage > 0) {
            setText(rejoinText)
        } else if (props.playerPrint){
            setText(downloadText)
        } else {
            setText(envelopeText)
        }
    }
    
    useEffect(() => {
        changeText()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    
    useEffect(() => {
        changeText()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.playerPrint])
    
    function handleClick() {
        props.callBackPage(props.playerStage)
    }
        
    return (
        <main>
            {props.playerStage === 0 ? <h1 id="landingTitle">Welcome Detectives!</h1> : <h1 id="landingTitle">Welcome Back Detectives!</h1>}
            <h3 id="logOut"><em onClick={props.callBackLogOut}>Not your game? Click here to log out.</em></h3>
            <div className="colourStripe blueTab centerBreak"></div>
            <div id="homeCardWrapper">
                <div id="instructionModule" className="homeCard">
                    <h1 className="redTab">Instructions - Read Me First!</h1>
                    <h3>Private Investigator Larry Maxwell needs your help on the latest case and there is no time to lose!
                    <br /><br />
                    {text}
                    <br /> <br />
                    Remember every detective needs a little help sometimes. Even Larry. <mark className="yellowTab">If you need a nudge in the right direction, you can request a hint using the NYPD Helpdesk at the bottom of each page.</mark>
                    <br/> <br/>
                    Good luck!
                    </h3>
                    {props.playerStage > 0 ? <button className="standardButton" onClick={handleClick}>Go To Part {props.playerStage}</button> : ""}
                </div>
                {props.playerPrint ? <DownloadCard handleDownload={props.handleDownload} playerStage={props.playerStage}/> : ""}
            </div>
            <div id="mainCornerCut"></div>
        </main>
    )
}

export default GameLanding